import { render, staticRenderFns } from "./PowerValueViewTwo.vue?vue&type=template&id=67a53b36&scoped=true&"
import script from "./PowerValueViewTwo.vue?vue&type=script&lang=js&"
export * from "./PowerValueViewTwo.vue?vue&type=script&lang=js&"
import style0 from "./PowerValueViewTwo.vue?vue&type=style&index=0&id=67a53b36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a53b36",
  null
  
)

export default component.exports